export type AuthBannerTone = 'error' | 'info'

export interface AuthBannerState {
  tone: AuthBannerTone
  message: string
}

export const AUTH_MESSAGES = {
  noAccount:
    'No account was found matching your Single Sign email. Use the email address registered ' +
    'with your Staffology account, or contact your administrator.',
  inactive: 'Your account is inactive. Please contact your administrator.',
  ssoCancelled:
    "Single Sign was cancelled, so you weren't signed in. Try again whenever you're ready.",
  ssoExpired: 'Your sign-in took too long and expired. Please sign in again.',
  sessionExpired: 'You were signed out because your session expired.',
  ssoStartFailed: 'Failed to initiate Single Sign. Please try again.',
} as const

const STATE_KEY = 'authBanner'

export function withAuthBanner(banner: AuthBannerState): {[STATE_KEY]: AuthBannerState} {
  return {[STATE_KEY]: banner}
}

export function readAuthBanner(state: unknown): AuthBannerState | null {
  if (!state || typeof state !== 'object') return null
  const banner = (state as Record<string, unknown>)[STATE_KEY]
  if (!banner || typeof banner !== 'object') return null
  const {tone, message} = banner as Partial<AuthBannerState>
  if ((tone !== 'error' && tone !== 'info') || typeof message !== 'string' || !message) return null
  return {tone, message}
}

export function withoutAuthBanner(state: unknown): Record<string, unknown> | null {
  if (!state || typeof state !== 'object') return null
  const {[STATE_KEY]: _banner, ...rest} = state as Record<string, unknown>
  return Object.keys(rest).length > 0 ? rest : null
}
